import { observer } from "mobx-react";
import { Note, NOTE_TYPE } from "../note/note";
import { BUTTON_VARIANTS } from "../inputs/button-variants";
import './return-guard-warning.scss';
import FontBody2 from "../fonts/font-body2/font-body2";
import IconWarning from "../icons/icon-warning/icon-warning";
import { useEffect, useRef } from "react";
import returnGuardWarningStore, { RETURN_GUARD_WARNING_TYPE } from "./return-guard-warning-store";
import useDashboardTranslation from "../../dashboard-translation/hooks/dashboard-translation-hook";
import { ButtonLink } from "../inputs/button-link/button-link";
import { useResizeDetector } from "react-resize-detector";
import { isSet } from "../../models/model-types-methods";
import { runInAction } from "mobx";

const ReturnGuardWarning: React.FC = observer(() => {
    const { getTranslation } = useDashboardTranslation();
    const returnGuardWarningRef = useRef<HTMLDivElement>(null);
    
    useEffect(() => {
        returnGuardWarningStore.load();
    }, []);

    const { height } = useResizeDetector({
        targetRef: returnGuardWarningRef,
        observerOptions: { box: 'border-box' },
    });

    useEffect(() => {
        if (isSet(height)) {
            returnGuardWarningStore.setHeight(height);
        }
    }, [height]);
    
    if (!returnGuardWarningStore.isShown) {
        return null;
    }

    const getNoteType = (): NOTE_TYPE => {
        if (returnGuardWarningStore.componentVariant === RETURN_GUARD_WARNING_TYPE.WARNING) {
            return NOTE_TYPE.WARNING
        }
        return NOTE_TYPE.ERROR;
    };

    const getButtonVariant = (): BUTTON_VARIANTS => {
        if (returnGuardWarningStore.componentVariant === RETURN_GUARD_WARNING_TYPE.WARNING) {
            /** TODO:: button is not orange and we do not have variant for orange button */
            return BUTTON_VARIANTS.Tertiary;
        }
        return BUTTON_VARIANTS.Dismiss;
        
    }

    const getIconColor = (): string => {
        if (returnGuardWarningStore.componentVariant === RETURN_GUARD_WARNING_TYPE.WARNING) {
            return 'var(--color-accent-4)';
        }
        return 'var(--color-accent-3)';
    }

    return (
        <div className="return-guard-warning-container" ref={returnGuardWarningRef}>
            <Note
                IconComponent={() => <IconWarning color={getIconColor()} />}
                type={getNoteType()}
                body={(
                    <div className="return-guard-warning-wrapper">
                        <div className="lock-warning-message">
                            <FontBody2>{ getTranslation(returnGuardWarningStore.warningTranslationKey, returnGuardWarningStore.translationScope, returnGuardWarningStore.translationArgs) }</FontBody2>
                        </div>
                        <div className="lock-warning-button">
                            <ButtonLink 
                                variant={getButtonVariant()}
                                text={getTranslation(returnGuardWarningStore.buttonTranslationKey, returnGuardWarningStore.translationScope)}
                                href={returnGuardWarningStore.buttonActionUrl}
                                target="_parent"
                            />
                        </div>
                    </div>
                )}
            />
        </div>
    );
});

export default ReturnGuardWarning;